<template>
	<div class="container-fluid">
		<div class="row">
			<div class="col-12 col-xl-10">
				<!--<p>
					<router-link tag="a" :to="{ name : 'admin.smes.index'}" class="button icon-button">
						<img src="../../../assets/images/icons/solid/angle-left-white.svg" width="8" class="mr-1" />
						<span>Back</span>
					</router-link>
				</p>-->
				<div class="row align-items-center justify-content-between">
					<div class="col-12 col-lg-4">
						<h4 class="mt-0 mb-4 pb-2 pt-2">Create SME</h4>
					</div><!--col-->
				</div><!--row-->
					
			</div><!--col-->
			<div class="col-12 col-xl-5">
				<form @submit.prevent="onSubmit">
					<div  class="lightgray-content p-3 rounded mb-4">
						<div class="form-group input-content">
							<label>Email</label>
							<input placeholder="Email" type="text" v-model="sme_data.email" class="form-control" v-validate="'required|email_unique'" name="email">
							<span class="input-error-msg">{{ errors.first('email') }}</span>
						</div>
						<div class="form-group input-content">
							<label>First name</label>
							<input placeholder="First name" type="text" v-model="sme_data.first_name" class="form-control" v-validate="'required'" name="first_name">
							<span class="input-error-msg">{{ errors.first('first_name') }}</span>
						</div>
						<div class="form-group input-content">
							<label>Last name</label>
							<input placeholder="Last name" type="text" v-model="sme_data.last_name" class="form-control" v-validate="'required'" name="last_name">
							<span class="input-error-msg">{{ errors.first('last_name') }}</span>
						</div>
					</div>
					<div class="text-right">
						<button type="submit" class="button large-button">Submit</button>
					</div>
				</form>
			</div><!--col-->
		</div><!--row-->
	</div>
</template>

<script>
export default {
	data : function(){
		return {
			sme_data : {
				email : '',
				first_name : '',
				last_name : ''
			}
		}
	},
	methods : {
		onSubmit : function(){
			this.$validator.validateAll().then((result) => {

				if(result){
					this.$store.dispatch('createSME', this.sme_data).then((res) => {

						this.$router.push({ name : 'admin.smes.index' });
					}).catch((error) => {
						
					});
				}
			});
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/admin/smes/AdminSMECreateComponent.vue